import CalendarTodayOutlined from "@mui/icons-material/CalendarTodayOutlined";
import { colors } from "healthex-common/colors";
import styled from "styled-components";
export const CalendarIcon = styled(CalendarTodayOutlined) `
    color: ${colors.sunset_main};
`;
